// TAŞIMA — başarı bildiriminde satır içi "GERİ AL".
// Zaman penceresi KULLANILMAZ: yalnızca bu taşımanın `batch_id`'sine ait
// GÖRÜNÜR activity kaydı hedeflenir (başka işlem geri alınmaz).
import { toast } from "sonner";
import { activityApi, tasksApi } from "./api";

// TEK ANAHTAR: satır içi GERİ AL'ı kapatmak için bunu false yap → normal
// başarı bildirimi gösterilir, başka dosyaya dokunmak gerekmez.
export const SATIR_ICI_GERI_AL_ACIK = true;
const TOAST_SURE_MS = 10000; // kullanıcı kararı: 10 saniye

const bekle = (ms) => new Promise((r) => setTimeout(r, ms));

// Kayıt backend'de ARKA PLANDA yazılır; hemen basılırsa henüz görünmeyebilir.
async function kaydiBul(activityId) {
  for (let deneme = 0; deneme < 4; deneme += 1) {
    const { items = [] } = await activityApi.list(100);
    const k = items.find((x) => x.id === activityId && !x.undone);
    if (k) return k;
    await bekle(700);
  }
  return null;
}

async function geriAl({ activityId, gorevIdler, refresh, kilit }) {
  if (kilit.calisiyor) return; // senkron kilit: ikinci istek gitmez
  kilit.calisiyor = true;
  try {
    const kayit = await kaydiBul(activityId);
    if (!kayit) {
      toast.error("Geri alınamadı: taşıma işlem kaydı bulunamadı — GERİ AL menüsünden deneyin", {
        duration: 9000,
      });
      return;
    }
    try {
      await activityApi.undo(kayit.id, true);
    } catch (e) {
      toast.error(
        e?.response?.data?.detail || "Geri alınamadı — GERİ AL menüsünden deneyin",
        { duration: 9000 },
      );
      return;
    }
    // DOĞRULAMA: sahte başarı YOK — kayıt gerçekten "geri alındı" oldu mu?
    let dogrulandi = false;
    try {
      const { items = [] } = await activityApi.list(100);
      dogrulandi = !!items.find((x) => x.id === kayit.id && x.undone);
    } catch (e) {
      console.warn("[moveUndo] doğrulama yapılamadı:", e);
    }
    refresh?.();
    if (dogrulandi) {
      toast.success("Taşıma geri alındı");
    } else {
      toast.error("Geri alınamadı — GERİ AL menüsünden deneyin", { duration: 9000 });
    }
    void gorevIdler;
  } finally {
    kilit.calisiyor = false;
  }
}

export function tasimaGeriAlBildirimi({ activityId, mesaj, gorevIdler = [], refresh }) {
  if (!SATIR_ICI_GERI_AL_ACIK || !activityId) {
    toast.success(mesaj);
    return;
  }
  const kilit = { calisiyor: false };
  toast.success(mesaj, {
    duration: TOAST_SURE_MS, // süre bitince kapanır; ana GERİ AL menüsü yine kullanılabilir
    action: {
      label: "GERİ AL",
      onClick: () => geriAl({ activityId, gorevIdler, refresh, kilit }),
    },
  });
}
